import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import UserAgentUtils from '../../utils/userAgent';
import { createNotification } from '../NotificationBar/actions';
import ApiUtils from '../../utils/api';
import { getOrFetchDriveItemMeta } from '../DriveItemList/actions';
import Utils from '../../utils';

enum ExternalLinkCreationPanelActionKeys {
	OPEN_PANEL = '@@externalLinkCreationPanel/OPEN_PANEL',
	CLOSE_PANEL = '@@externalLinkCreationPanel/CLOSE_PANEL',
	SET_VALUE = '@@externalLinkCreationPanel/SET_VALUE',
}

type ExternalLinkCreationPanelAction =
	OpenPanelAction |
	ClosePanelAction |
	SetValueAction;

interface OpenPanelAction extends Action {
	type: ExternalLinkCreationPanelActionKeys.OPEN_PANEL;
}

interface ClosePanelAction extends Action {
	type: ExternalLinkCreationPanelActionKeys.CLOSE_PANEL;
}

interface SetValueAction extends Action {
	type: ExternalLinkCreationPanelActionKeys.SET_VALUE;
	name: string;
	value: string;
	error: string | null;
}

const openPanel = (): OpenPanelAction => ({
	type: ExternalLinkCreationPanelActionKeys.OPEN_PANEL,
});

const closePanel = (): ClosePanelAction => ({
	type: ExternalLinkCreationPanelActionKeys.CLOSE_PANEL,
});

const setValue = (name: string, value: string, error: string | null): SetValueAction => ({
	type: ExternalLinkCreationPanelActionKeys.SET_VALUE,
	name,
	value,
	error,
});

const createExternalLink = (name: string, url: string) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	const folderId = Utils.getFolderIdForPrivateResource();
	const isOnline = await UserAgentUtils.isOnlinePromise();

	if (isOnline && folderId) {
		try {
			await ApiUtils.createExternalLink(folderId, name, url);
			await dispatch(getOrFetchDriveItemMeta(folderId, true, true, true));
		} catch (error) {
			dispatch(createNotification('error.cant_create_external_link'));
		} finally {
			dispatch(closePanel());
		}
	} else {
		dispatch(createNotification('info.offline_create_external_link'));
		dispatch(closePanel());
	}
};

export {
	ExternalLinkCreationPanelActionKeys,
	ExternalLinkCreationPanelAction,
	createExternalLink,
	openPanel,
	closePanel,
	setValue,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ExternalLinkCreationPanel/actions.ts